import { ProductData } from "data/product/products";

export enum STYLE_TYPES {
  REGULAR = "REGULAR",
  LIGHT = "LIGHT",
}

export interface Props {
  productData: ProductData;
  isInEditMode: boolean;
  itemType?: string;
  indexBackgroundGlow?: boolean;
}
